export const UserType = {
  Regular: 'Regular',
  Dealer: 'Dealer',
}
